import { GET_SEARCH_LIST, UPDATE_RECENT_SEARCH, GET_RECENT_SEARCH_LIST, GET_DISTRICT_LIST, GET_BLOCKBYDISTRICT_LIST, GET_CLUSTERBYBLOCK_LIST } from "../actions/GlobalSearchActions";

const initialState = {// initialize states
  optionList: [],
  recentSearch: [],
  DistrictList: [],
  BlockList: [],
  ClusterList: [],
};

const GlobalSearchReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_SEARCH_LIST: { // save search data into state
      return {
        ...state,
        optionList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_RECENT_SEARCH_LIST: { // save recent search data into state
      return {
        ...state,
        recentSearch: action.payload.data ? action.payload.data : [],
      };
    }
    case UPDATE_RECENT_SEARCH: { // update recent search data into state
      return {
        ...state,
        recentSearch: [...state.recentSearch, action.payload._source],
      };
    }
    case GET_DISTRICT_LIST: { // save district data into state
      return {
        ...state,
        DistrictList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_BLOCKBYDISTRICT_LIST: { // save block by district data into state
      return {
        ...state,
        BlockList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_CLUSTERBYBLOCK_LIST: { // save cluster by block data into state
      return {
        ...state,
        ClusterList: action.payload.data ? action.payload.data : [],
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default GlobalSearchReducer;
